import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { utilTracking } from "../../../utils/tracking/utilTracking";
import { ShopType } from "../../game-tracking/types/ShopTypeEnum";
import { actionModalCloseAll, actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TypeActionShop } from "../actionShop";
var checkoutPage;
export var epicShopPurchaseRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionShop.RequestPurchase), switchMap(function (action) {
        var state = state$.value;
        var selectedProvider = action.selectedProvider, offer = action.offer;
        var locale = state.loca.lang;
        var playerId = selectPlayerInfo(state).playerId;
        var description = utilLoca.get(offer.locaKeyTitle);
        var shopId = ShopType.Shop3;
        var shopSessionId = utilTracking.getStartTime();
        var shopStepCount = utilTracking.getShopStateCount();
        checkoutPage = window.open("about:blank", "_blank");
        return deps.netSend({
            id: CommandCode.WebShopCheckout,
            props: {
                description: description,
                itemId: offer.shopPackage.id,
                locale: locale,
                playerId: playerId,
                providerId: selectedProvider.id,
                purchaseOfferCharacteristicId: offer.offerCharacteristicId,
                purchaseOfferNameId: offer.purchaseOfferNameId,
                shopId: shopId,
                shopSessionId: shopSessionId,
                shopStepCount: shopStepCount,
            },
        });
    }), retry(), switchMap(function (res) {
        if (checkoutPage && !checkoutPage.closed && checkoutPage.location) {
            checkoutPage.location.href = res.checkoutURL;
        }
        return from([actionModalCloseAll(), actionModalOpen(IdModal.Shop)]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/epics/epicShopPurchaseRequest.ts
// module id = 2341
// module chunks = 3